// extracted by mini-css-extract-plugin
export var actionButton = "_ee-t";
export var buttonContainer = "_ee-0";
export var buttonContainer2 = "_ee-1";
export var buttonSection = "_ee-2";
export var details = "_ee-3";
export var dropdownItem = "_ee-5";
export var dropdownItemsContainer = "_ee-4";
export var fileInput = "_ee-r";
export var headerButton = "_ee-6";
export var icon = "_ee-7";
export var input = "_ee-8";
export var macroListItem = "_ee-9";
export var mainContent = "_ee-a";
export var microText = "_ee-b";
export var modal = "_ee-w";
export var optionsButton = "_ee-c";
export var paperclip = "_ee-s";
export var pillContent = "_ee-d";
export var preview = "_ee-e";
export var preview2 = "_ee-f";
export var quillEditor = "_ee-q";
export var selectedMacro = "_ee-g";
export var sidebar = "_ee-h";
export var sidebarHeader = "_ee-j";
export var sidebarList = "_ee-i";
export var sidebarListItem = "_ee-k";
export var sidebarSearch = "_ee-l";
export var snoozeDurationWrapper = "_ee-v";
export var statusPillContainer = "_ee-m";
export var tagsContainer = "_ee-n";
export var unselectedMacro = "_ee-o";
export var variable = "_ee-u";
export var wrapper = "_ee-p";